import { useState } from 'react'
import { useSnackbar } from "notistack"
import { CircularProgress } from '@material-ui/core'
import { DadosArquivos } from '../styles'
import { CloudDownload } from '@material-ui/icons'
import ComunicacaoControleService from "../../../../services/ComunicacaoControleService"
import webconfig from '../../../../webconfig.json'

export default function ArquivoLinha({ arquivo, motivoRecusa }) {

    const [loading, setLoading] = useState(false)

    const { enqueueSnackbar } = useSnackbar()

    const downloadArquivo = (arquivo) => {
        setLoading(true)
        ComunicacaoControleService.DownloadArquivoDocumento8Bits(
            arquivo.id,
            arquivo.arquivoAnexoOrigemId,
            arquivo.tipoArquivo)
            .then(response => {
                if (response.status === 200) {
                    let contentDisposition = response.headers['content-disposition'];
                    let nomeArquivo = '';

                    if (contentDisposition) {
                        // Tenta extrair filename*=UTF-8''nome.ext
                        let utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
                        if (utf8Match && utf8Match[1]) {
                            nomeArquivo = decodeURIComponent(utf8Match[1]);
                        } else {
                            // Tenta extrair filename=nome.ext
                            let regularMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                            if (regularMatch && regularMatch[1]) {
                                nomeArquivo = regularMatch[1];
                            }
                        }
                    }

                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const fileURL = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = fileURL;
                    a.download = nomeArquivo;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    // limpa da memória
                    URL.revokeObjectURL(fileURL);

                    enqueueSnackbar('Download realizado com sucesso', { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoading(false)
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }

            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    return (
        <DadosArquivos.ListaArquivos>
            {arquivo !== null && arquivo !== undefined ?
                <>
                    <DadosArquivos.Acao title="Download" onClick={() => downloadArquivo(arquivo)}>
                        {
                            loading
                                ?
                                <CircularProgress
                                    size={22}
                                    style={{
                                        color: '#22b636'
                                    }} />
                                : <CloudDownload />
                        }
                    </DadosArquivos.Acao>
                    <DadosArquivos.NomeArquivo title={arquivo.nomeArquivo}>
                        {<span style={{ float: 'left' }}>{arquivo.nomeArquivo}</span>}<span style={{ float: 'right', paddingRight: '5px' }}>{arquivo.dataEnvioCompleta}</span>
                    </DadosArquivos.NomeArquivo>
                </>
                :
                <div style={{ float: 'inline-start', backgroundColor: '#ebebeb', marginBottom: '10px' }}>
                    {motivoRecusa &&
                        (<span style={{ marginLeft: '10px', color: 'red' }}><strong>{'Motivo da recusa: '}</strong>{motivoRecusa}</span>)
                    }
                </div>
            }
        </DadosArquivos.ListaArquivos>
    )
}